import styled from "styled-components";
import { ButtonStyle } from "../../../globalStyles";

export const Container = styled.section`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 26vw;
  margin-top: 40px;

  .wave-form img {
    width: 42vw;

    @media (max-width: 1000px) {
      width: 100%;
    }
  }

  .hero-section {
    .header {
      font-family: ${props => props.theme.p1m.ff};
      color: ${props => props.theme.textLight};
      font-size: 36px;
      max-width: 72%;
      margin-bottom: 36px;
      line-height: 49px;
      font-size: 36px;
    }

    .hero-button {
      ${ButtonStyle}
      border: none;
      width: 210px;
      height: 37px;
      background: ${props => props.theme.highlight};
      color: ${props => props.theme.white};
      font-size: ${props => props.theme.p1b.fs};
    }

    .sub-text {
      font-size: ${props => props.theme.p1m.fs};
      font-family: ${props => props.theme.p1m.ff};
      max-width: 50%;
      color: ${props => props.theme.white};
      margin-top: 36px;
      line-height: 24px;
      text-shadow: 0px 2px 7px rgba(0, 0, 0, 0.342002);
    }
  }

  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100vw;

    .gemscape-mobile {
      width: 100vw;
    }
    .hero-section {
      display: flex;
      flex-direction: column;

      .header {
        width: 100%;
        max-width: 90vw;
        margin-left: 26px;
        margin-bottom: 24px;
        font-size: 24px;
        line-height: 30px;
      }
      .sub-text {
        max-width: 100%;
        margin-left: 32px;
        margin-right: 12px;
      }
    }

    .hero-button {
      margin-left: 26px;
      margin-top: 40px;
    }
  }
`;
